import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';
import { WidgetService } from 'src/app/services/widget.service';
import { FilterType, FilterTypes } from '../../edit/edit-userfilter/edit-userfilter.component';
import { USERFILTER_FORMGROUP } from '../user-filter-dialog/classes';

@Component({
  selector: 'app-filter-form',
  templateUrl: './filter-form.component.html',
  styleUrls: ['./filter-form.component.css']
})
export class FilterFormComponent implements OnDestroy, OnInit {

  appearance: 'fill' | 'outline' | 'standard' = 'fill';
  currentFilterType: FilterType<number>;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(USERFILTER_FORMGROUP) public formGroup: FormGroup,
    private _filterService: FilterService,
    private _widgetService: WidgetService
  ) { }

  deleteFilter = () => this._widgetService.deleteWidgetUserFilter(this.filteridControl.value).subscribe(() => window.location.reload());
  deleteFilterCondition = () => this._filterService.deleteFilter(this.filterControl.value).subscribe(() => window.location.reload());

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.filtertypeControl.valueChanges.subscribe((value: string) => this.setFilterType(value))
    ]);
    this.setFilterType(this.filtertypeControl.value);
  }

  setFilterType = (type: string) => this.currentFilterType = FilterTypes.find(x => x.value === type);

  FilterTypes = FilterTypes;

  get filterbackgroundcolorControl(): AbstractControl {
    return this.formGroup.controls['filterbackgroundcolor'];
  }
  get filtercolorControl(): AbstractControl {
    return this.formGroup.controls['filtercolor'];
  }
  get filtericonControl(): AbstractControl {
    return this.formGroup.controls['filtericon'];
  }
  get filteridControl(): AbstractControl {
    return this.formGroup.controls['filterid'];
  }
  get filterControl(): AbstractControl {
    return this.formGroup.controls['filter'];
  }
  get filterObjectControl(): AbstractControl {
    return this.formGroup.controls['filteR1'];
  }
  get filtertextControl(): AbstractControl {
    return this.formGroup.controls['filtertext'];
  }
  get filtertypeControl(): AbstractControl {
    return this.formGroup.controls['filtertype'];
  }
  get filtersortdscControl(): AbstractControl {
    return this.formGroup.controls['filtersortdsc'];
  }
}
